import React from 'react';
import FileUpload from './fileUpladV2';
import translate from '@data/translations';
import { deleteDocument, openDocument } from './api';
import { BlobDocumentModel, ValueLabelString } from '@common/modelDefinition';

interface FolderBoxProps {
    documents: any;
    onFolderUpdated?: Function;
    defaultFileIconPlaceholder?: any;
    openBtnStyle?: string;
    openBtnContent?: any;
    deleteBtnStyle?: string;
    deleteBtnContent?: any;
    uploadButtonStyle?: string;
    uploadButtonText?: string;
    showDeleteButton?: boolean;
    showOpenFileButton?: boolean;
    showFileUploadButton?: boolean;
    category?: string;
    setCloseFolderBox?: Function;
    selectOptions?: string[];
    showNewDocument?: BlobDocumentModel;
    setDocumentation?: Function;
    documentation?: BlobDocumentModel[];
    setAttachedDocuments?:Function
    inputWrapperClass?:string
    dontShowDocumentName?:boolean
}

const FolderBox = (props: FolderBoxProps) => {
    const {
        documents: documentsRaw,
        onFolderUpdated,
        defaultFileIconPlaceholder,
        openBtnStyle,
        openBtnContent,
        deleteBtnStyle,
        deleteBtnContent,
        showDeleteButton,
        showOpenFileButton,
        showFileUploadButton,
        uploadButtonStyle,
        uploadButtonText,
        category,
        setCloseFolderBox,
        selectOptions,
        showNewDocument,
        setDocumentation,
        documentation,
        setAttachedDocuments,
        inputWrapperClass,
        dontShowDocumentName

    } = props;
    const [documents, setDocuments] = React.useState([] as any[]);
    const [isFileUploading, setIsFileUploading] = React.useState(false as boolean);

    React.useEffect(() => {
        if (documentsRaw) {
            if (typeof documentsRaw === 'string') {
                const parsedDocuments = JSON.parse(documentsRaw);
                setDocuments(parsedDocuments);
            } else {
                setDocuments(documentsRaw);
            }
        } else {
            setDocuments([]);
        }
    }, [documentsRaw]);
    const onFileUploadedHandler = (fileInfo: BlobDocumentModel) => {
        const newDocuments = [...documents];

        newDocuments.push(fileInfo);
        setDocuments(newDocuments);
     
        if (onFolderUpdated) {
            onFolderUpdated(JSON.stringify(newDocuments));
        }
    };

    const setFileUploading = (isUploading: boolean) => {
        setIsFileUploading(isUploading);
    };
    
    const getDocumentIconBasedOnFileType = (docInfo: any) => {
        let result = null;
        const _defaultFileIconPlaceholder = defaultFileIconPlaceholder ? (
            defaultFileIconPlaceholder
        ) : (
            <i className="fa fa-file"></i>
        );

        switch (docInfo.type) {
            case 'image/jpeg':
            case 'image/png':
                result = <i className="fa fa-file-image-o"></i>;
                break;
            case 'application/json':
                result = <i className="fa fa-file-text-o"></i>;
                break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                result = <i className="fa fa-file-word-o"></i>;
                break;
            case 'application/pdf':
                result = <i className="fa fa-file-pdf-o"></i>;
                break;
            default:
                result = _defaultFileIconPlaceholder;
                break;
        }
        return result;
    };

    let openBtnStyleDefault = openBtnStyle ? openBtnStyle : 'btn btn-primary btn-sm mr-8p';
    let openBtnContentDefault = openBtnContent ? openBtnContent : <i className="fa fa-download" aria-hidden="true"></i>;
    let deleteBtnStyleDefault = deleteBtnStyle ? deleteBtnStyle : 'btn btn-sm btn-danger mr-1 pull-right';
    let deleteBtnContentDefault = deleteBtnContent ? (
        deleteBtnContent
    ) : (
        <i className="fa fa-trash" aria-hidden="true"></i>
    );

    let uploadButtonStyleDefault = uploadButtonStyle ? uploadButtonStyle : 'btn btn-info btn-sm mr-8p';
    let uploadButtonTextDefault = uploadButtonText ? uploadButtonText : translate('Upload a file');
    let showDeleteButtonDefault = showDeleteButton !== undefined ? showDeleteButton : true;
    let showOpenFileButtonDefault = showOpenFileButton !== undefined ? showOpenFileButton : true;
    let showFileUploadButtonDefault = showFileUploadButton !== undefined ? showFileUploadButton : true;

    const selectOptionsPreview: ValueLabelString[] = [];
    let sections =selectOptions ? [...selectOptions] : [];
    sections = sections.sort((a, b) => (a > b ? 1 : -1));
    sections.forEach((t) => {
        let obj: ValueLabelString = { value: '', label: '' };
        obj.value = t;
        obj.label = t;
        selectOptionsPreview.push(obj);
    });

    // const selectValue = showNewDocument?.category?.includes('_')
    //     ? { value: showNewDocument.category.split('_')[0], label: showNewDocument.category.split('_')[0] }
    //     : { value: '', label: '' };

    return (
        <div>
            {/* {setCloseFolderBox  && selectOptions? (
                <div className="">
                    <div className="form-group">
                        <label htmlFor="">{translate('Section')}:</label>
                        <Select
                            isClearable={true}
                            className=""
                            name="type"
                            placeholder={translate('Slice pricelist by tags')}
                            options={selectOptionsPreview}
                            onChange={(value) => {
                                const editedNewDocument = { ...showNewDocument };
                                if (value) {
                                    const target = value.label + '_' + category;
                                    editedNewDocument.category = target;
                                    setCloseFolderBox(editedNewDocument);
                                } else {
                                    if (showNewDocument?.category?.includes('_')) {
                                        const target = showNewDocument.category.split('_')[1];
                                        editedNewDocument.category = target;
                                        setCloseFolderBox(editedNewDocument);
                                    }
                                }
                            }}
                            value={selectValue}
                        ></Select>
                    </div>
                </div>
            ) : null} */}
            <div>
                {documents.map((doc) => {
                    if (!doc.uuid) {
                        return null;
                    }
                    let documentIcon = getDocumentIconBasedOnFileType(doc);
                    return (
                        <div key={doc.uuid} className={dontShowDocumentName ? "" : "custom-list-item"}>
                           {!dontShowDocumentName ? <div>
                                {documentIcon}&ensp;{doc.name}
                            </div> : null}
                            <div className="flex-center">
                                {showOpenFileButtonDefault ? (
                                    <div
                                        className={openBtnStyleDefault}
                                        onClick={() => {
                                            openDocument(doc);
                                        }}
                                    >
                                        {openBtnContentDefault}
                                    </div>
                                ) : null}
                                {showDeleteButtonDefault ? (
                                    <div
                                        className={deleteBtnStyleDefault}
                                        onClick={async () => {
                                            await deleteDocument(doc);
                                            const newDocuments = documents.filter((d) => d.uuid !== doc.uuid);
                                            setDocuments(newDocuments);
                                            if (onFolderUpdated) {
                                                onFolderUpdated(JSON.stringify(newDocuments));
                                            }
                                        }}
                                    >
                                        {deleteBtnContentDefault}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    );
                })}
                {isFileUploading ? (
                    <div className="custom-list-item">
                        <i className="fa fa-spin fa-spinner"></i>{" "}
                        {translate('uploading file')}
                    </div>
                ) : null}
            </div>

            {showFileUploadButtonDefault ? (
                <div className={inputWrapperClass ? "flex-center-left mt-8p": "flex-center-center mt-8p"}>
                    <FileUpload
                        uploadButtonText={uploadButtonTextDefault}
                        onFileUploaded={onFileUploadedHandler}
                        setFileUploading={setFileUploading}
                        uploadButtonStyle={uploadButtonStyleDefault}
                        category={showNewDocument?.category ? showNewDocument.category : category}
                        inputWrapperClass = {inputWrapperClass}
                    />
                    {setCloseFolderBox && !setAttachedDocuments? (
                        <div
                            onClick={() => {
                                if (documentation && setDocumentation) {
                                    const newDocumentation = [...documentation];
                                    for (const document of documents) {
                                        if (document.uuid) {
                                            const isExist = documentation.find((d) => d.uuid === document.uuid);
                                            if (!isExist) {
                                                newDocumentation.push(document);
                                            }
                                        }
                                    }
                                    setDocumentation(newDocumentation);
                                }

                                setCloseFolderBox(null);
                            }}
                        >
                            <input
                                id="file"
                                className="inputfile"
                                type="file"
                                name="file"
                                onChange={() => {
                                    return null;
                                }}
                            />
                            <label className={'btn btn-secondary btn-sm uppercase'} htmlFor="">
                                {translate('Close')}
                            </label>
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default FolderBox;
